import React, { useState } from 'react';
import styles from './style.less';
import { useRequest, request, useLocation } from 'umi';
import {
  message,
  DatePicker,
  Button,
  Row,
  Col,
  Image,
  Checkbox,
  Space,
} from 'antd';
import dayjs from 'dayjs';

let apiPrefix = 'https://open.mokan.cn';
const dataSource = [
  {
    value: 'HUMAN',
    label: '人形快照',
  },
  {
    value: 'GENERAL',
    label: '普通快照',
  },
];

export default () => {
  const location = useLocation();
  const {
    type,
    projectId,
    contractNo,
    timestamp,
    clientCode,
    deviceId,
    serialNumber,
    sign,
  } = location.query;

  if (type === 'test') {
    apiPrefix = 'https://test-open.mokan.cn';
  }

  const [selectDate, setSelectDate] = useState(dayjs());
  const [selectType, setSelectType] = useState([]);

  const tempObj = {
    startTime: selectDate,
    endTime: selectDate,
  };

  tempObj.snapshotType = selectType;
  if (contractNo) {
    tempObj.contractNo = contractNo;
  } else if (projectId) {
    tempObj.projectId = projectId;
  }
  if (deviceId) {
    tempObj.deviceId = deviceId;
  }
  if (serialNumber) {
    tempObj.serialNumber = serialNumber;
  }

  const _getData = () => {
    if (!tempObj.projectId && !tempObj.contractNo) {
      return message.error('参数缺失');
    }
    return request(`${apiPrefix}/openapi/projectSnapshot/getSnapshotList`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      // params: {
      //   ...tempObj,
      // },
      data: {
        ...tempObj,
      },
    });
  };

  const { data, loading, run } = useRequest(
    () => {
      return _getData();
    },
    {
      onSuccess(response) {},
      // refreshDeps: [selectType, selectDate], //改成点击查询按钮手动调用
    },
  );

  if (!data) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className="mb10">
        <Space>
          <span>
            施工日期：
            <DatePicker
              onChange={(date, dateString) => {
                setSelectDate(dateString);
              }}
              defaultValue={selectDate}
            />
          </span>
          <span>
            快照类型：
            <Checkbox.Group
              options={dataSource}
              value={selectType}
              onChange={(checkedValues) => {
                setSelectType(checkedValues);
              }}
            />
          </span>
          <Button
            type="primary"
            onClick={() => {
              run();
            }}
          >
            查询
          </Button>
        </Space>
      </div>
      {data?.data[0]?.snapshots?.length > 0 ? (
        <Row gutter={[20, 20]}>
          {data?.data[0]?.snapshots?.map((v) => {
            return (
              <Col span={6} key={v?.url}>
                <Image width="100%" height="auto" src={v?.url} />
                <div>{v?.time}</div>
              </Col>
            );
          })}
        </Row>
      ) : (
        <div className="temp">
          <div className="title">暂无资源</div>
        </div>
      )}
    </div>
  );
};
